/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Code} from "./code.zod";
import {CustomerOfferStatus} from "./customerOfferStatus.zod";
import {Language} from "./language.zod";

export const listCustomerOffersParamsSortKeyDefault = `name`;

export const listCustomerOffersParamsLatestOnlyDefault = false;
export const ListCustomerOffersParams = zod.object({
  sortKey: zod
    .enum(["name", "offerOrdinal", "version"])
    .default(listCustomerOffersParamsSortKeyDefault),
  expedientId: zod.uuid().optional(),
  offerOrdinal: zod.int().min(1).optional(),
  version: zod.int().min(1).optional(),
  status: CustomerOfferStatus.optional(),
  q: zod.string().optional(),
  language: Language.optional(),
  currencyCode: Code.optional(),
  statuses: zod.array(CustomerOfferStatus).min(1).optional(),
  latestOnly: zod.boolean().default(listCustomerOffersParamsLatestOnlyDefault),
});

export type ListCustomerOffersParams = zod.input<typeof ListCustomerOffersParams>;
export type ListCustomerOffersParamsOutput = zod.output<typeof ListCustomerOffersParams>;
